import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSynchronizeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "7 7 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		className: "sync-icon-st0",
		d: "M11.9987 7.33398V5.58398L9.66536 7.91732L11.9987 10.2507V8.50065C13.9295 8.50065 15.4987 10.0698 15.4987 12.0007C15.4987 12.5898 15.3529 13.1498 15.0904 13.634L15.942 14.4857C16.397 13.7682 16.6654 12.9165 16.6654 12.0007C16.6654 9.42232 14.577 7.33398 11.9987 7.33398ZM11.9987 15.5007C10.0679 15.5007 8.4987 13.9315 8.4987 12.0007C8.4987 11.4115 8.64453 10.8515 8.90703 10.3673L8.05536 9.51565C7.60036 10.2332 7.33203 11.0848 7.33203 12.0007C7.33203 14.579 9.42036 16.6673 11.9987 16.6673V18.4173L14.332 16.084L11.9987 13.7507V15.5007Z",
		fill: "currentColor"
	})
});
export default SvgSynchronizeIcon;
